import MenuSzgztIcon from '@/components/icon/menuSzgzt'
import MenuQyzbkIcon from '@/components/icon/menuQyzbk'
import MenuSjzdIcon from '@/components/icon/menuSjzd'
import MenuJcqddeIcon from '@/components/icon/menujcqdde'
import MenuCostIcon from '@/components/icon/menuCost'
import MenuXtrz from '@/components/icon/menuXtrz'
import MenuJcsjwh from '@/components/icon/menuJcsjwh'
import MenuZbApply from '@/components/icon/menuZbApply'
import { ApartmentOutlined, BarChartOutlined, BorderOuterOutlined, SettingOutlined } from '@ant-design/icons'
import { SystemEnum } from '@/config/enum'
import BasicInfoIcon from '@/components/icon/documentIcon/basic-info'
import DomainIcon from '@/components/icon/documentIcon/domain'
import TemplateIcon from '@/components/icon/documentIcon/template'
import DictIcon from '@/components/icon/documentIcon/dict'
import EngIcon from '@/components/icon/documentIcon/eng'

// const isDebug = window.location.href.includes('isdebug=1')

// 系统设置  project-center
const systemMenuList = [
  {
    title: '项目中心',
    key: 'project-center',
    icon: <ApartmentOutlined />,
    path: '/project-center',
    children: [
      {
        path: '/project-center/list',
        title: '项目列表',
        key: '/project-center/list',
      },
    ]
  },
  {
    title: '数据字典',
    icon: <MenuSjzdIcon />,
    key: 'dict',
    children: [
      {
        path: '/dict/info2',
        title: '项目信息',
        key: '/dict/info2',
      },
      {
        path: '/dict/feature2',
        title: '工程特征',
        key: '/dict/feature2',
      },
      {
        path: '/dict/projectSpecial',
        title: '工程专业',
        key: '/dict/projectSpecial',
      },
      {
        path: '/dict/projectCategory',
        title: '工程分类',
        key: '/dict/projectCategory',
      },
    ],
  },
  {
    path: '/inventory',
    title: '清单定额库',
    icon: <MenuJcqddeIcon />,
    key: '/inventory',
    children: [
      {
        path: '/inventory/list',
        title: '清单库',
        key: '/inventory/list',
      },
      {
        path: '/inventory/ration',
        title: '定额库',
        key: '/inventory/ration',
      },
      {
        path: '/inventory/laborMaterialsMachinery',
        title: '人材机库',
        key: '/inventory/laborMaterialsMachinery',
      },
    ],
  },
]

// 造价指标菜单
const zbglMenuList = [
  {
    path: '/indicator-brief/summary',
    title: '简报看板',
    icon: <BarChartOutlined style={{ fontSize: '19px' }} />,
    key: '/indicator-brief/summary',
  },
  {
    path: '/indicator',
    title: '指标采集',
    key: 'indicator',
    icon: <MenuSzgztIcon style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/indicator/englist',
        title: '指标工程',
        key: '/indicator/englist',
      },
    ],
  },
  {
    path: '/indicator-view',
    title: '指标查询',
    key: 'indicator-view',
    // icon: <BarChartOutlined style={{ fontSize: '19px' }} />,
    icon: <MenuQyzbkIcon style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/indicator-view/km',
        title: '科目指标',
        key: '/indicator-view/km',
      },
      {
        path: '/indicator-view/eng',
        title: '工程指标',
        key: '/indicator-view/eng',
      },
      {
        path: '/indicator-view/qdzhdj',
        title: '清单综合单价',
        key: '/indicator-view/qdzhdj',
      },
      {
        path: '/indicator-view/glj',
        title: '工料机价格',
        key: '/indicator-view/glj',
      },
    ],
  },
  {
    path: '/indicator-apply',
    title: '指标应用',
    key: 'indicator-apply',
    icon: <MenuZbApply style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/indicator-apply/costControlCompare',
        title: '费控对比',
        key: '/indicator-apply/costControlCompare',
      },
      {
        path: '/indicator-apply/standard',
        title: '指标标准',
        key: '/indicator-apply/standard',
      },
      {
        path: '/indicator-apply/application',
        title: '指标报表',
        key: '/indicator-apply/application',
      },
    ],
  },
  {
    path: '/cost-control',
    title: '成本管控',
    key: 'cost-control',
    icon: <MenuCostIcon style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/investment/estimate',
        title: '投资估算',
        key: '/investment/estimate',
      },
      {
        path: '/cost-control/contract-plan',
        title: '合约规划',
        key: '/cost-control/contract-plan',
      },
    ],
  },
  {
    path: '/application-template',
    title: '指标模板',
    key: 'application-template',
    icon: <MenuJcqddeIcon style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/indicator/collectorTemplate',
        title: '指标模板',
        key: '/indicator/collectorTemplate',
      },
      {
        path: '/indicator/officialTemplate2',
        title: '报表模板',
        key: '/indicator/officialTemplate2',
      },
      {
        path: '/indicator/contractTemplate',
        title: '合约模板',
        key: '/indicator/contractTemplate',
      },
    ],
  },
  {
    path: '/zjDict',
    title: '数据字典',
    icon: <MenuSjzdIcon />,
    key: 'zjDict',
    children: [
      {
        path: '/zjDict/info3',
        title: '指标工程信息',
        key: '/zjDict/info3',
      },
      {
        path: '/zjDict/gsgc',
        title: '估算工程信息',
        key: '/zjDict/gsgc',
      },
      {
        path: '/zjDict/subjectAttr',
        title: '科目属性',
        key: '/zjDict/subjectAttr',
      },
      {
        path: '/zjDict/indicatorStandard',
        title: '标准属性',
        key: '/zjDict/indicatorStandard',
      },
      {
        path: '/zjDict/costingPhase',
        title: '造价阶段',
        key: '/zjDict/costingPhase',
      },
      {
        path: '/zjDict/invoiceType',
        title: '单据类型',
        key: '/zjDict/invoiceType',
      },
    ],
  },
  {
    path: '/zj-system',
    title: '系统设置',
    icon: <SettingOutlined />,
    key: 'zj-system',
    children: [
      {
        path: '/zj-system/allocationRules',
        title: '分摊规则',
        key: '/zj-system/allocationRules',
      },
      {
        path: '/zj-system/verifySetting',
        title: '校验设置',
        key: '/zj-system/verifySetting',
      },
      {
        path: '/zj-system/fee-standard',
        title: '费率标准',
        key: '/zj-system/fee-standard',
      },
      {
        path: '/zj-system/adjust-factor',
        title: '调差因子',
        key: '/zj-system/adjust-factor',
      },
    ],
  },
  {
    path: '/systemData',
    title: '鲁班数据',
    icon: <BorderOuterOutlined />,
    key: 'luban',
    meta: {
      auth: {
        isSuperAdmin: true,
        isDefaultEpid: true
      }
    },
    children: [
      {
        path: '/systemData/glj',
        title: '系统工料机',
        key: '/systemData/glj',
      },
      {
        path: '/systemData/unit',
        title: '系统单位',
        key: '/systemData/unit',
      },
      {
        path: '/systemData/unitChange',
        title: '单位转换',
        key: '/systemData/unitChange',
      },
      {
        path: '/systemData/collectTemplateRules',
        title: '指标模板规则',
        key: '/systemData/collectTemplateRules',
      },
    ],
  },
  {
    path: '/indicator-log',
    title: '日志管理',
    key: 'indicator-log',
    icon: <MenuXtrz style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/indicator/operlog',
        title: '操作日志',
        key: '/indicator/operlog',
      },
    ],
  },
]

// 量价协同
const ljxtMenuList = [
  {
    title: '成本方案',
    icon: <MenuCostIcon />,
    key: 'cost',
    children: [
      {
        path: '/cost/list',
        title: '成本科目库',
        key: '/cost/list',
      },
      {
        path: '/cost/split',
        title: '自动拆分方案',
        key: '/cost/split',
      },
    ],
  },
]

// 项目业绩
const yjkMenuList = [
  {
    title: '业绩管理',
    icon: <MenuSzgztIcon style={{ fontSize: '32px' }} />,
    key: 'cloud-project',
    children: [
      {
        path: '/cloud-project/list',
        title: '项目列表',
        key: '/cloud-project/list',
      },
      {
        path: '/cloud-project/document-list',
        title: '资料列表',
        key: '/cloud-project/document-list',
      },
    ],
  },
  {
    title: '统计分析',
    icon: <MenuJcqddeIcon style={{ fontSize: '32px' }} />,
    key: '/cloud-project/analysis',
    path: '/cloud-project/analysis',
  },
  {
    title: '基础数据维护',
    key: 'template',
    icon: <MenuJcsjwh style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/template/list',
        title: '项目模板',
        key: '/template/list',
      },
      {
        path: '/field/list',
        title: '字段设置',
        key: '/field/list',
      },
      {
        path: '/cloud-project/base-partner',
        title: '合作单位',
        key: '/cloud-project/base-partner',
      },
      {
        path: '/cloud-project/dict-list',
        title: '数据字典',
        key: '/cloud-project/dict-list',
      },
      {
        path: '/cloud-project/code-rule',
        title: '编码规则',
        key: '/cloud-project/code-rule',
      },
    ],
  },
  {
    title: '系统日志',
    key: 'log',
    icon: <MenuXtrz style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/log/list',
        title: '操作日志',
        key: '/log/list',
      },
    ],
  },
]

// 资料文档
const zlwdMenuList = [
  {
    title: '资料编制',
    key: 'document',
    icon: <EngIcon style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/document/engList',
        title: '资料工程',
        key: '/document/engList',
      },
    ],
  },
  {
    title: '基础信息',
    key: 'document-baseinfo',
    icon: <BasicInfoIcon style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/document/enterpriseInfo',
        title: '企业信息',
        key: '/document/enterpriseInfo',
      },
      {
        path: '/document/personInfo',
        title: '人员信息',
        key: '/document/personInfo',
      },
    ]
  },
  {
    title: '模板管理',
    key: 'document-template',
    icon: <TemplateIcon style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/document/templateList',
        title: '文档模板',
        key: '/document/templateList',
      },
      {
        path: '/document/dirList',
        title: '文档目录',
        key: '/document/dirList',
      },
      // 资料包模板
      {
        path: '/document/packageTemplateList',
        title: '资料包模板',
        key: '/document/packageTemplateList',
      },
    ],
  },
  {
    title: '字段域管理',
    key: 'document-domain',
    icon: <DomainIcon style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/document/domainList',
        title: '字段域',
        key: '/document/domainList',
      },
    ],
  },
  {
    title: '数据字典',
    key: 'document-dict',
    icon: <DictIcon style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/document/engDict',
        title: '工程类型',
        key: '/document/engDict',
      },
      {
        path: '/document/projectInfoDict',
        title: '项目属性',
        key: '/document/projectInfoDict',
      },
      {
        path: '/document/enterpriseInfoDict',
        title: '企业属性',
        key: '/document/enterpriseInfoDict',
      },
      {
        path: '/document/personInfoDict',
        title: '人员属性',
        key: '/document/personInfoDict',
      },
      {
        path: '/document/signDict',
        title: '签名身份',
        key: '/document/signDict',
      },
    ],
  },
]

// 上海燃气
const shryMenuList = [
  {
    path: '/shry-standard',
    title: '标准设置',
    key: 'shry-standard',
    icon: <MenuZbApply style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/shry/unit-price-standard',
        title: '单价标准',
        key: '/shry/unit-price-standard',
      },
      {
        path: '/shry/project-standard',
        title: '标准化项目',
        key: '/shry/project-standard',
      }
    ],
  },
  {
    title: '物料管理',
    key: 'shry-material',
    icon: <MenuJcqddeIcon style={{ fontSize: '32px' }} />,
    children: [
      {
        path: '/shry/list',
        title: '燃气物料库',
        key: '/shry/list',
      },
    ],
  },
  {
    title: '系统设置',
    key: 'shry-system',
    icon: < SettingOutlined />,
    children: [
      {
        path: '/shry/fee-standard',
        title: '费率标准',
        key: '/shry/fee-standard',
      },
    ],
  },
]

export const menuKeysMap = {
  [SystemEnum.SYSTEM]: systemMenuList, // 系统设置
  [SystemEnum.YJGL]: yjkMenuList, // 项目业绩
  [SystemEnum.ZBGL]: zbglMenuList, // 造价指标
  [SystemEnum.LJXT]: ljxtMenuList, // 量价协同
  [SystemEnum.ZLWD]: zlwdMenuList, // 资料文档
  [SystemEnum.SHRY]: shryMenuList, // 上海燃气
}
